import { render, staticRenderFns } from "./Planday.vue?vue&type=template&id=70b4d0cb&"
import script from "./Planday.vue?vue&type=script&lang=js&"
export * from "./Planday.vue?vue&type=script&lang=js&"
import style0 from "./Planday.vue?vue&type=style&index=0&id=70b4d0cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports